import React from 'react';
import {useNavigate} from 'react-router-dom';
import './NewsPreview.css';

import NewsList from '../../components/NewsList';
import {newsItems} from '../../content/news/newsItems';
import {newsImageMap} from '../../content/news/newsImages';

function NewsPreview() {
  const navigate = useNavigate();

  const latestThree = newsItems.slice(0, 3);

  return (
    <div className='newssection mt-5 mb-3'>
      <div>
        <h2>News</h2>

        <NewsList
          items={latestThree}
          imageMap={newsImageMap}
          mode='cards'
        />
      </div>

      <button
        onClick={() => navigate('/news')}
        className='btnLightDark px-3 py-1 reviewLink'>
        more news
      </button>
    </div>
  );
}

export default NewsPreview;
